import { Box, FormControl, MenuItem, Select, Stack, Typography } from '@mui/material';
import { Container } from '@mui/system';
import React from 'react';
import { useTypedSelector } from '../../store/hooks';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../../store/features/common/common.slice';
import pkgFile from '../../../package.json';
import { theme } from '../../styles/theme';
import langFile from '../../data/lang.json';

const Header: React.FC = () => {
    const dispatch = useDispatch();
    const { lang } = useTypedSelector(state => state.common);

    return (
        <Box
            sx={{
                height: 40,
                backgroundColor: theme.palette.primary.main,
                display: 'flex',
                alignItems: 'center',
                color: '#fff'
            }}>
            <Container 
                maxWidth="md"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                <Typography 
                    sx={{
                        fontWeight: 600
                    }}
                    variant="h6">{(langFile.appTitle as any)[lang]}</Typography>
                
                <Stack 
                    alignItems="center"
                    direction="row" 
                    gap={2}>
                    <FormControl 
                        size="small">
                        <Select
                            variant="standard"
                            sx={{
                                '& .MuiInputBase-input': {
                                    color: '#fff',
                                    
                                },
                                '& .MuiSvgIcon-root': {
                                    color: '#fff',
                                }
                            }}
                            value={lang}
                            onChange={e => dispatch(setLanguage(e.target.value))}
                        >
                            <MenuItem value="kz">Qaz</MenuItem>
                            <MenuItem value="ru">Rus</MenuItem>
                            <MenuItem value="en">Eng</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography variant="caption">v{pkgFile.version}</Typography>
                </Stack>
            </Container>
        </Box>
    )
}

export default Header;